<div class="app-added-stations profile-page-content">
  <app-stations-list contributionType="CREATE" [userId]="userId"></app-stations-list>
</div>
